import { jsxs, jsx } from "react/jsx-runtime";
import { TriangleChart } from "./TriangleChart.js";
const DOMAIN_LABELS = {
  abstraction: "무시",
  change: "변화",
  relation: "관계"
};
const DOMAIN_DESCRIPTIONS = {
  abstraction: "불필요한 요소를 무시하고 핵심을 파악하는 능력",
  change: "변환과 변화를 인식하고 표현하는 능력",
  relation: "개념 간 관계를 파악하고 연결하는 능력"
};
const PRE_COLOR = "#3b82f6";
const POST_COLOR = "#8b5cf6";
function AiqTriangleSection({ report, phase }) {
  const maxScore = 100;
  const { thresholds } = report;
  const buildDomainScores = () => {
    const domains = ["abstraction", "change", "relation"];
    if (phase === "comparison") {
      return domains.map((d) => {
        var _a, _b;
        const preVal = ((_a = report.preDomainScores) == null ? void 0 : _a[d]) ?? 0;
        const postVal = ((_b = report.postDomainScores) == null ? void 0 : _b[d]) ?? 0;
        return {
          label: DOMAIN_LABELS[d],
          value: preVal,
          color: PRE_COLOR,
          comparisonValue: postVal,
          comparisonColor: POST_COLOR
        };
      });
    }
    const scores = phase === "pre" ? report.preDomainScores : report.postDomainScores;
    const color = phase === "pre" ? PRE_COLOR : POST_COLOR;
    return domains.map((d) => ({
      label: DOMAIN_LABELS[d],
      value: (scores == null ? void 0 : scores[d]) ?? 0,
      color
    }));
  };
  const buildOverallScores = () => {
    if (phase === "comparison") {
      return [{
        label: "전체",
        value: report.preOverallScore ?? 0,
        color: PRE_COLOR,
        comparisonValue: report.postOverallScore ?? 0,
        comparisonColor: POST_COLOR
      }];
    }
    const val = phase === "pre" ? report.preOverallScore : report.postOverallScore;
    const color = phase === "pre" ? PRE_COLOR : POST_COLOR;
    return [{ label: "전체", value: val ?? 0, color }];
  };
  const getImprovementAnnotations = () => {
    var _a, _b;
    if (phase !== "comparison") return null;
    const annotations2 = [];
    const domains = ["abstraction", "change", "relation"];
    for (const d of domains) {
      const pre = ((_a = report.preDomainScores) == null ? void 0 : _a[d]) ?? 0;
      const post = ((_b = report.postDomainScores) == null ? void 0 : _b[d]) ?? 0;
      if (post > pre) {
        const diff = Math.round(post - pre);
        annotations2.push(`${DOMAIN_LABELS[d]} 능력이 ${diff}점 향상되었습니다! 🎉`);
      }
    }
    const preTotal = report.preOverallScore ?? 0;
    const postTotal = report.postOverallScore ?? 0;
    if (postTotal > preTotal) {
      const diff = Math.round(postTotal - preTotal);
      annotations2.push(`전체 점수가 ${diff}점 향상! 꾸준한 학습의 성과입니다.`);
    }
    return annotations2;
  };
  const annotations = getImprovementAnnotations();
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-6 justify-center", children: [
      /* @__PURE__ */ jsx(
        TriangleChart,
        {
          scores: buildDomainScores(),
          thresholds,
          title: "분야별 점수",
          maxScore,
          showArrows: phase === "comparison",
          width: 220,
          height: 280
        }
      ),
      /* @__PURE__ */ jsx(
        TriangleChart,
        {
          scores: buildOverallScores(),
          thresholds,
          title: "전체 점수",
          maxScore,
          showArrows: phase === "comparison",
          width: 160,
          height: 280
        }
      )
    ] }),
    phase === "comparison" && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-6 text-xs text-gray-500", children: [
      /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx("span", { className: "inline-block w-3 h-3 rounded-full", style: { backgroundColor: PRE_COLOR } }),
        "Pre-AIQ"
      ] }),
      /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx("span", { className: "inline-block w-3 h-3 rounded-full", style: { backgroundColor: POST_COLOR } }),
        "Post-AIQ"
      ] })
    ] }),
    annotations && annotations.length > 0 && /* @__PURE__ */ jsx("div", { className: "bg-green-50 border border-green-200 rounded-lg p-3 space-y-1", children: annotations.map((a, i) => /* @__PURE__ */ jsx("p", { className: "text-sm text-green-700", children: a }, i)) }),
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 gap-2 text-xs text-gray-500", children: ["abstraction", "change", "relation"].map((d) => /* @__PURE__ */ jsxs("div", { className: "text-center", children: [
      /* @__PURE__ */ jsx("span", { className: "font-semibold text-gray-700", children: DOMAIN_LABELS[d] }),
      /* @__PURE__ */ jsx("p", { className: "mt-0.5", children: DOMAIN_DESCRIPTIONS[d] })
    ] }, d)) })
  ] });
}
export {
  AiqTriangleSection
};
//# sourceMappingURL=AiqTriangleSection.js.map
